<template>
  <div class="pl-0">
    <div
        class="pl-0"
        style="position: relative;">
      <v-form

          ref="form"
          v-model="subscription"
          @submit=""
          onSubmit="return false;"
          lazy-validation="">

        <v-card flat color="transparent" @click="load_form_block(content)">
          <blocks-functions-form-fields
              :items="content.items"
          >
          </blocks-functions-form-fields>
        </v-card>
      </v-form>

    </div>

  </div>
</template>

<script>
import BlocksFunctionsFormFields from "@/components/Blocks/Functions/FormFields.vue";

export default {
  props: {
    content: Object
  },
  components: {BlocksFunctionsFormFields},
  data() {
    return {
      show_options: false,
      subscription: true
    }
  },
  methods: {
    load_form_block(item) {
      let payload = {
        active: true,
        index: 0,
        item: item
      }
      this.$store.dispatch('setFormBlock', payload);
    },
    close_form_opts() {
      this.form_dialog = false;
    },
    delete_field(index) {
      if (confirm(' Are you sure you want to delete this field ?')) {
        this.content.items.splice(index, 1);
      }
    }
  }
}
</script>

